<!-- Modal para seleccionar avatares -->
<div *ngIf="isModalOpen" class="modal-overlay w-full" (click)="closeAvatarModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <span class="close cursor-pointer bg-red-500 text-white px-2 py-1 rounded hover:bg-primary absolute top-2 right-2" (click)="closeAvatarModal()">X</span>
    <h3>Elige un Avatar</h3>
    <div class="avatar-selection">
      <img *ngFor="let avatar of avatars; let i = index" [src]="avatar" [alt]="'Avatar ' + (i + 1)" class="avatar-thumbnail" (click)="selectAvatar(avatar)" />
    </div>
    <div class="selected-avatar">
      <h3 class="mb-2 text-primary text-3xl">Tu avatar seleccionado:</h3>
      <img *ngIf="selectedAvatar" [src]="selectedAvatar" alt="Selected Avatar" />
      <button (click)="closeAvatarModal()" class="botoo flex items-center justify-center mt-4 animate-pulse rounded-md bg-black text-white">Guardar</button>
    </div>
  </div>
</div>

<form
  [formGroup]="profileForm"
  (ngSubmit)="submitForm()"
  class="mb-5 rounded-md border border-primary bg-white p-4 dark:border-white text-black dark:text-white dark:bg-[#0e1726] animate__animated animate__zoomInUp"
>
  <h6 class="mb-5 text-lg font-bold">{{ 'HOME-PROFILE.INFO' | translate }}</h6>
  <div class="flex flex-col sm:flex-row">
    <div class="mb-5 w-full sm:w-2/12 ltr:sm:mr-4 rtl:sm:ml-4 relative">
      <div>
        <img [src]="selectedAvatar" alt="Avatar seleccionado" class="avatar-image" />
        <button class="add-avatar-btn absolute animate-pulse" (click)="openAvatarModal()">
          <icon-pencil-paper />
        </button>
      </div>
    </div>
    <div class="grid flex-1 grid-cols-1 gap-5 sm:grid-cols-2">
      <!-- NOMBRE -->
      <div>
        <label for="name">{{ 'HOME-PROFILE.NAME' | translate }}</label>
        <input id="name" type="text" formControlName="name" placeholder="{{ profile.name.first_name }}" class="form-input border-black dark:border-white" />
        <small class="text-red-500" *ngIf="profileForm.get('name')?.invalid && profileForm.get('name')?.touched"> ⚠️ Nombre es obligatorio </small>
      </div>

      <!-- APELLIDO -->
      <div>
        <label for="lastname">{{ 'HOME-PROFILE.LASTNAME' | translate }}</label>
        <input id="lastname" type="text" formControlName="lastname" placeholder="{{ profile.name.last_name }}" class="form-input border-black dark:border-white" />
        <small class="text-red-500" *ngIf="profileForm.get('lastname')?.invalid && profileForm.get('lastname')?.touched"> ⚠️ Apellido es obligatorio </small>
      </div>

              <!-- EMAIL -->
        <div>
        <label for="email">{{ 'HOME-PROFILE.EMAIL' | translate }}</label>
        <input id="email" type="email" formControlName="email" [value]="profile.email" class="form-input border-black dark:border-white" />
        <small class="text-red-500" *ngIf="profileForm.get('email')?.invalid && profileForm.get('email')?.touched"> ⚠️ Email es obligatorio </small>
      </div>

      <!-- País -->
      <div>
        <label for="country">{{ 'HOME-PROFILE.Pais' | translate }}</label>
        <select id="country" formControlName="country" class="form-select text-white-dark border-black dark:border-white" (change)="onCountryChange($event)">
          <option value="" disabled selected>{{ profile.country.name }}</option>
          <option *ngFor="let country of countries" [value]="country.cca2">{{ country.name.nativeName.es.common }}</option>
        </select>
      </div>

      <!-- Departamento -->
      <div>
        <label for="department">{{ 'HOME-PROFILE.DEPARTAMENT' | translate }}</label>
        <select
          id="department"
          formControlName="department"
          class="form-select text-white-dark border-black dark:border-white"
          (change)="onDepartmentChange($event)"
          [disabled]="!states.length"
        >
          <option value="" disabled selected>{{ profile.department.name }}</option>
          <option *ngFor="let state of states" [value]="state.state_code">{{ state.state_name }}</option>
        </select>
      </div>

      <!-- Ciudad -->
      <div>
        <label for="city">{{ 'HOME-PROFILE.CITY' | translate }}</label>
        <select id="city" formControlName="city" class="form-select text-white-dark border-black dark:border-white" [disabled]="!cities.length">
          <option value="" disabled selected>{{ profile.city.name }}</option>
          <option *ngFor="let city of cities" [value]="city.city_code">{{ city.city_name }}</option>
        </select>
      </div>

      <div>
        <label for="phone">{{ 'HOME-PROFILE.PHONE' | translate }}</label>
        <input id="phone" type="number" formControlName="phone" class="form-input border-black dark:border-white" placeholder="{{ profile.phone.number }}" />
      </div>

      <!-- CONTRASEÑA -->
      <div>
        <label for="password">{{ 'HOME-PROFILE.PASSWORD' | translate }}</label>
        <input id="password" type="password" formControlName="password" placeholder="********" class="form-input border-black dark:border-white" />
        <small class="text-red-500" *ngIf="profileForm.get('password')?.invalid && profileForm.get('password')?.touched">
          ⚠️ La contraseña debe:
          <ul class="list-disc ml-4">
            <li>Tener al menos 6 caracteres</li>
            <li>Incluir al menos una letra mayúscula</li>
            <li>Incluir al menos una letra minúscula</li>
            <li>Incluir al menos un número</li>
          </ul>
        </small>
      </div>

      <!-- CONFIRMAR CONTRASEÑA -->
      <div>
        <label for="confirmPassword">{{ 'HOME-PROFILE.CONFIRMPASSWORD' | translate }}</label>
        <input
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
          placeholder="********"
          class="form-input border-black dark:border-white"
        />
        <small class="text-red-500" *ngIf="profileForm.get('confirmPassword')?.invalid && profileForm.get('confirmPassword')?.touched">
          ⚠️ Debes confirmar tu contraseña
        </small>
        <small class="text-red-500" *ngIf="profileForm.get('confirmPassword')?.errors?.['mismatch']">
            ⚠️ Las contraseñas no coinciden
          </small>
      </div>

      <div (click)="submitForm()" class="mt-3 sm:col-span-2">
        <button type="submit" class="btn btn-primary" [disabled]="profileForm.invalid">
          {{ 'HOME-PROFILE.BUTTON' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>

<!-- <form class="rounded-md border border-primary bg-white p-6 dark:border-[#191e3a] dark:bg-[#0e1726]">
  <h2 class="mb-5 text-lg font-bold text-center text-black dark:text-white">
    {{ 'HOME-PROFILE.PAY' | translate }}
  </h2>

  <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
    <div>
      <label for="soat" class="block mb-2 text-sm font-bold text-primary text-center"> SOAT </label>
      <div class="flex items-center">
        <div class="flex items-center justify-center rounded bg-primary px-3 font-semibold dark:bg-[#1b2e4b] ltr:mr-2 rtl:ml-2">
          <icon-user-plus class="h-8 w-5 text-white border-black dark:border-white" />
        </div>
        <input id="soat" type="date" class="form-input flex-1 rounded-md border-black dark:border-white p-2 dark:bg-[#1b2e4b] dark:text-white" />
      </div>
    </div>

    <div>
      <label for="tecnico-mecanica" class="block mb-2 text-sm font-bold text-primary text-center"> Técnico-Mecánica </label>
      <div class="flex items-center">
        <div class="flex items-center justify-center rounded bg-primary px-3 font-semibold dark:bg-[#1b2e4b] ltr:mr-2 rtl:ml-2">
          <icon-user-plus class="h-8 w-5 text-white border-black dark:border-white" />
        </div>
        <input id="tecnico-mecanica" type="date" class="form-input flex-1 rounded-md border border-black dark:border-white dark:bg-[#1b2e4b] dark:text-white" />
      </div>
    </div>
  </div>
</form> -->
